"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchMembers = exports.getAvailableTypes = void 0;

const utils_1 = require("../utils");

const getAvailableTypes = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/search/available-types`;
  const body = {
    email: options.email
  };
  return jilFetch(path, null, {
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
};

exports.getAvailableTypes = getAvailableTypes;

const getSearchMembers = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/search/members`;
  const params = utils_1.omitIfNil({
    include_user_groups: options.includeUserGroups,
    page: options.pageNumber,
    page_size: options.pageSize,
    search_query: options.filterQuery,
    sort: options.sortExpression,
    sort_order: options.sortOrder,
    target_license_group_id: options.targetLicenseGroupId,
    target_product_id: options.targetProductId,
    target_type: options.targetType,
    target_user_group_id: options.targetUserGroupId
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getSearchMembers = getSearchMembers;